import styled from 'styled-components';
import {
	SurfaceColor,
	DividerColor,
	Grey500,
	Yellow,
	Green,
	ShadowColor
} from '../../Colors';
import {TextButtonBase} from '../../atoms/TextButton';
import Divider from '../../atoms/Divider';
import {ThumbsUpIcon,StarIcon,TwitterIcon} from '../../atoms/Icons';

const defaultStyle = {
	Wrapper : styled.div`
		padding : 1rem;
		box-shadow: 0px 8px 16px 0px ${ShadowColor};
        border-radius : 5px;
		background-color : ${SurfaceColor};
	`,
	UserAndRecipe : styled.div`
		display : flex;
	`,
	Divider,
	UsersWrapper : styled.div`
		width : 300px;
	`,
	SnsWrapper : styled.div`
		padding-left : 2rem;
		padding-bottom : 1rem;
	`,
	TwitterIcon : styled(TwitterIcon)`
		margin-right : 1rem;
		font-size : 3rem;
	`,
	UserName : styled.h4`
		padding : 1rem;
		margin : 0;
	`,
	UserIcon : styled.img.attrs({
		width : '250px',
		height : '250px'
	})`
		margin-left : 2rem;
		border-radius : 1rem;
	`,
	Comment : styled.p`
		margin-top : 2rem;
		padding-left : 2rem;
		white-space: pre-wrap;
	`,
	Recipes : styled.div`
		padding : 1rem;
		margin-left : 2rem;
		& > label {
			margin-bottom : 2rem;
		}
	`,
	RecipeWrapper : styled.div`
		display : flex;
		align-items : center;
		border-bottom : 1px solid ${DividerColor};
		min-width : 400px;
		&>:last-child{
			margin-left : auto;
		}
	`,
	Recipe : styled(TextButtonBase)`
		padding : 1rem 1rem 0.5rem 1rem;
		width : 100%;
		text-align : left;
		
	`,
	RecipeStatus : styled.div`
		font-size : 1rem;
		color : ${Grey500};
	`,
	StarIcon : styled(StarIcon)`
		font-size : 2rem;
		color : ${Yellow};
	`,
	ThumbsUpIcon : styled(ThumbsUpIcon)`
		font-size : 2rem;
		margin-left : 1rem;
		color : ${Green};
	`,
};

const mobileStyle = {
	Wrapper : styled.div`
		background-color : ${SurfaceColor};
		padding-bottom : 2rem;
	`,
	Divider,
	UsersWrapper : styled.div`
	`,
	SnsWrapper : styled.div`
		padding-left : 2rem;
		padding-bottom : 1rem;
	`,
	TwitterIcon : styled(TwitterIcon)`
		margin-right : 1rem;
		font-size : 3rem;
	`,
	UserName : styled.h4`
		padding : 1rem;
		margin : 0;
	`,
	UserIcon : styled.img.attrs({
		width : '250px',
		height : '250px'
	})`
		margin-left : 2rem;
		border-radius : 1rem;
	`,
	Comment : styled.p`
		padding-top : 1rem;
		padding-left : 1rem;
		white-space: pre-wrap;
	`,
	Recipes : styled.div`
		padding : 1rem;
	`,
	Recipe : styled(TextButtonBase)`
		padding : 1rem 1rem 0.5rem 1rem;
		width : 100%;
		text-align : left;
		display : block;
		position : relative;
		border-bottom : 1px solid ${DividerColor};
	`,
	RecipeStatus : styled.div`
		position : absolute;
		right : 1rem;
		top : 1rem;
		font-size : 1rem;
		color : ${Grey500};
	`,
	StarIcon : styled(StarIcon)`
		font-size : 2rem;
		color : ${Yellow};
	`,
	ThumbsUpIcon : styled(ThumbsUpIcon)`
		font-size : 2rem;
		margin-left : 1rem;
		color : ${Green};
	`,
};

export default defaultStyle;
export {mobileStyle};
